import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";
import { UserLogin } from "../models/userlogin";

@Injectable({ providedIn: "root" })
export class AuthenticationService {
  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  userLogin = <UserLogin>{
    Password: "",
    Username: "",
  };

  constructor(private readonly http: HttpClient) {}

  isAuthenticated() {
    let token = localStorage.getItem(CONSTANTS.TOKEN_KEY);
    return token != null;
  }

  getToken() {
    return localStorage.getItem(CONSTANTS.TOKEN_KEY);
  }

  login(username: string, password: string) {
    this.userLogin.Username = username;
    this.userLogin.Password = password;
    let user = JSON.stringify({
      login: this.userLogin,
      userDevice: {
        Id: 0,
        UserID: 0,
        DeviceId: "string",
        DeviceName: "string",
        DeviceToken: "string",
        Platform: "string",
        OSVersion: "string",
        GeneratedDate: "2022-07-05T07:09:00.698Z",
        LastUpdateDate: "2022-07-05T07:09:00.698Z",
      },
    });
    return this.http
      .post<any>(
        environment.BASE_API_URL + CONSTANTS.API.ACCOUNT.LOGIN,
        user,
        this.headers
      )
      .pipe(
        map((value) => {
          localStorage.setItem(
            CONSTANTS.TOKEN_KEY,
            value?.result.token.toString()
          );
          return value;
        })
      );
  }

  logout() {
    localStorage.removeItem(CONSTANTS.TOKEN_KEY);
  }
}
